import { useState, useEffect } from "react";
import { BsFileWordFill } from "react-icons/bs";
import Loading from "../../../utils/Loading";
import Button from "../../Button";
import { FaFileUpload, FaFileWord } from "react-icons/fa";
import { Alert } from "../../../utils/Alert";
import api from "../../../Services/api";
import { Url_Docs } from "../../../assets/URL'S/Url_Docs";
import {
  Background,
  Cardo,
  CursoTurmaDiscInfo,
  DivMain,
  DivSave,
  DivTitle,
  DragAndDropArea,
  FileDetails,
  FileInfo,
  HiddenFileInput,
  Infos,
  Instructions,
  PdfEmbed,
} from "../CardAddEditProgressao/style";

const InsirirVerDocExemplar = ({ show, setShow, perfil }) => {
  if (!show) return null;

  const [files, setFiles] = useState([]);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [deletando, setDeletando] = useState(false);
  const [escolha, setEscolha] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [viewFileUrl, setViewFileUrl] = useState(""); // Estado para armazenar a URL do arquivo a ser visualizado
  const [srcVideo, setSrcVideo] = useState("");

  useEffect(() => {
    if (!show) return;
    setLoading(true);
    fetchVideo();
    // if (escolha === 2) {
    //   fetchFiles(); // Busca os arquivos do backend ao escolher "Ver Arquivos"
    // }
    // if (perfil === "prof") {
    //   setEscolha(2);
    // }
    // const handleResize = () => {
    //   setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    // };
    // window.addEventListener("resize", handleResize);
    // return () => window.removeEventListener("resize", handleResize);
  }, [show /*, escolha*/]);

  const fetchVideo = async () => {
    try {
      const response = await api.get("/video/Progressão parcial", { responseType: "blob" });
      const videoBlob = new Blob([response.data], { type: "video/mp4" });
      const videoUrl = URL.createObjectURL(videoBlob);
      setSrcVideo(videoUrl);
      document.querySelector("video")?.focus();
    } catch (error) {
      console.error("Erro ao buscar o vídeo:", error);
      Alert({ tipo: "Erro", mensagem: "Não foi possível carregar o vídeo." });
      return;
    } finally {
      setLoading(false);
    }
  };

  const fetchFiles = async () => {
    setLoading(true);
    try {
      const response = await api.get(Url_Docs()); // Fazendo a requisição para a rota '/docs'
      setFiles(response.data.arquivos); // Armazena a lista de arquivos na state
    } catch (error) {
      console.error("Erro ao buscar os arquivos:", error);
      Alert({ tipo: "Erro", mensagem: "Não foi possível carregar os arquivos." });
    } finally {
      setLoading(false);
    }
  };

  const PC = windowSize.width >= 1000;
  const Pocket = windowSize.width <= 600;

  function Fechar(e) {
    e.preventDefault();
    setFile(null);
    setDragActive(false);
    setEscolha(null);
    setLoading(false);
    setShow(false);
    setViewFileUrl(""); // Fechar visualização de documento
  }

  async function Enviar(e) {
    e.preventDefault();
    if (file) {
      try {
        setUploading(true);
        const formData = new FormData();
        formData.append("file", file);
        const response = await api.post("/coordenador/enviar-docx-exemplar", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        await Alert({ tipo: "Sucesso2", mensagem: response.data.mensagem || "Sucesso ao salvar o arquivo!" });
      } catch (error) {
        console.error("Erro ao enviar o arquivo:", error);
        setUploading(false);
        Alert({ tipo: "Erro", mensagem: error.response.data.mensagem || "Erro ao salvar o arquivo!" });
      } finally {
        setEscolha(null);
        setFile(null);
        setFileUrl(null);
        setFileSize(null);
        setViewFileUrl("");
        setUploading(false);
        // window.location.reload();
      }
    }
  }

  function DeletarDocx(e, fileName) {
    Alert({ tipo: "Alert", mensagem: `Deseja deletar o arquivo: ${fileName}!` }).then(async (result) => {
      if (result.isConfirmed) {
        setDeletando(true);
        e.preventDefault();
        try {
          const response = await api.delete(`/coordenador/deletar-docx-exemplar`, {
            params: { fileName },
          });
          return await Alert({ tipo: "Sucesso2", mensagem: response.data.mensagem || "Sucesso ao deletar o arquivo!" });
        } catch (error) {
          console.error("Erro ao deletar o arquivo:", error);
          return Alert({ tipo: "Erro", mensagem: error.response.data.mensagem || "Erro ao deletar o arquivo!" });
        } finally {
          setDeletando(false);
          const response = await api.get(Url_Docs()); // Fazendo a requisição para a rota '/docs'
          setFiles(response.data.arquivos);
          // window.location.reload();
        }
      }
    });
  }

  function formatFileSize(size) {
    const units = ["B", "KB", "MB", "GB", "TB"];
    let index = 0;
    while (size >= 1024 && index < units.length - 1) {
      size /= 1024;
      index++;
    }
    return `${size.toFixed(2)} ${units[index]}`;
  }

  const sanitizeFilename = (str) => {
    return str
      .toLowerCase()
      .normalize("NFD") // Normaliza a string separando os acentos
      .replace(/[\u0300-\u036f]/g, ""); // Remove os acentos
  };

  const handleFileChange = (selectedFile) => {
    if (
      selectedFile &&
      selectedFile.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ) {
      const sanitizedName = sanitizeFilename(selectedFile.name); // Nome sanitizado
      const newFile = new File([selectedFile], sanitizedName, { type: selectedFile.type }); // Novo File com o nome sanitizado

      setFile(newFile); // Define o novo arquivo
      setFileUrl(URL.createObjectURL(newFile)); // Atualiza a URL do arquivo
      setFileSize(formatFileSize(newFile.size)); // Atualiza o tamanho do arquivo
    } else {
      Alert({ tipo: "Erro", mensagem: "Por favor, selecione um arquivo .docx válido." });
    }
  };

  const handleDownload = async (fileName) => {
    try {
      const response = await api.get(Url_Docs(fileName), { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Erro ao baixar o arquivo:", error);
      Alert({ tipo: "Erro", mensagem: "Não foi possível baixar o arquivo." });
    }
  };

  const handleView = (fileName) => {
    const url = Url_Docs(fileName); // Obter URL base do ambiente atual
    setViewFileUrl(`https://docs.google.com/gview?url=${url}&embedded=true`);
  };

  return (
    <Background>
      <Cardo $escolha={true} style={{ minHeight: "fit-content" }}>
        <DivTitle>
          <h1>Visão geral da progressão parcial</h1>
        </DivTitle>
        <DivMain style={{ minHeight: "300px" }}>
          {loading ? (
            <Loading />
          ) : (
            srcVideo && (
              <video controls autoPlay style={{ maxHeight: "450px", borderRadius: 4, border: "1px solid black" }}>
                <source src={srcVideo} type="video/mp4" />
              </video>
            )
            /* 
        <DivMain $escolha={escolha == 2}>
          {loading ? (
            <Loading />
          ) : (
            <>
              {escolha === null && perfil === "coord" && (
                  <Button
                    type="button"
                    width="11rem"
                    height="100%"
                    background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                    placeholder="Inserir Novo Documento"
                    event={() => setEscolha(1)}
                  />
                  <Button
                    type="button"
                    width="10rem"
                    height="100%"
                    background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                    placeholder="Vizualizar Documentos"
                    event={() => setEscolha(2)}
                  />
                </div>
              )}
              {escolha === 1 && perfil === "coord" && (
                <>
                  {file ? (
                    <FileInfo>
                      <FaFileWord
                        size={"25rem"}
                        color="#0c44be4b"
                        style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
                      />
                      <div>
                        <span>Arquivo: {file.name}</span>
                        <FileDetails>Tamanho: {fileSize}</FileDetails>
                      </div>
                      {file && (
                        <Button
                          width={Pocket ? "4rem" : "10rem"}
                          event={() => {
                            setFile(null);
                            setFileUrl(null);
                            setFileSize(null);
                          }}
                          placeholder={"Remover"}
                          background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                          borderRadius="10px"
                          padding={!PC && "10px"}
                          fontSize={!PC && "12px"}
                        />
                      )}
                    </FileInfo>
                  ) : (
                    <DragAndDropArea
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragActive(true);
                      }}
                      onDragLeave={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDragActive(false);
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const droppedFile = e.dataTransfer.files[0];
                        handleFileChange(droppedFile);
                        setDragActive(false);
                      }}
                      dragActive={dragActive}
                    >
                      <Instructions>
                        {dragActive ? (
                          "Solte o arquivo aqui..."
                        ) : (
                          <>
                            <FaFileUpload
                              size={PC ? "25rem" : "10rem"}
                              color="#7c7c7c30"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            />
                            Arraste (ou clique aqui) um arquivo em .DOCX (Word) do modelo da progressão parcial
                          </>
                        )}
                      </Instructions>
                      <HiddenFileInput
                        type="file"
                        accept=".docx"
                        onChange={(e) => handleFileChange(e.target.files[0])}
                      />
                    </DragAndDropArea>
                  )}
                </>
              )}
              {escolha === 2 && (
                <>
                  {viewFileUrl && <PdfEmbed src={viewFileUrl} title="Visualizador de Documento" />}
                  {!files.length ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10%",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <h3>Nenhum arquivo.</h3>
                    </div>
                  ) : (
                    <>
                      <Infos $escolha={true}>
                        {files.map((fileName, index) => (
                          <CursoTurmaDiscInfo
                            style={{ maxWidth: "215px", minWidth: "215px", minHeight: "110px", gap: 20 }}
                            key={index}
                          >
                            <div className="DivIcon">
                              <span>{fileName.replace(/[_-]/g, " ") || fileName}</span>
                              {// <BsFileWordFill className="icon" /> 
                              }
                            </div>
                            <div className="DivButton">
                              <Button
                                type="button"
                                width={perfil === "prof" ? "10rem" : "6rem"}
                                placeholder="Baixar"
                                background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                                event={() => handleDownload(fileName)}
                                padding={"10px"}
                                fontSize={"12px"}
                              />
                              {perfil !== "prof" && (
                                <Button
                                  type="button"
                                  width={"6rem"}
                                  placeholder="Deletar"
                                  background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
                                  event={(e) => DeletarDocx(e, fileName)}
                                  padding={"10px"}
                                  fontSize={"12px"}
                                  disabled={deletando}
                                />
                              )}
                            </div>
                          </CursoTurmaDiscInfo>
                        ))}
                      </Infos>
                      {/* <DivCard>
                        {files.map((fileName, index) => (
                          <Card key={index}>
                            <div className='icon'>
                              <BsFileWordFill />
                            </div>
                            <div className='content'>
                              <span>{fileName.replace(/[_-]/g, ' ') || fileName}</span>  
                              <Button
                                type="button"
                                width="10rem"
                                placeholder="Baixar"
                                event={() => handleDownload(fileName)}
                              />
                            </div>
                          </Card>
                        ))}
                      </DivCard> 
                    </>
                  )}
                </>
              )}
              {/* Se houver uma URL de arquivo para visualização, renderiza o iframe 
            </>
          )}
        </DivMain>
        <DivSave>
          {escolha !== null && perfil !== "prof" ? (
            <Button
              event={() => {
                setEscolha(null);
                setFile(null);
                setFileUrl(null);
                setFileSize(null);
                setViewFileUrl(""); // Limpa a URL de visualização
              }}
              width={Pocket ? "6rem" : "10rem"}
              placeholder={"Voltar"}
              background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
              borderRadius="10px"
              padding={!PC && "10px"}
              fontSize={!PC && "12px"}
            />
          ) : (
            )}
            {file && (
              <Button
              width={Pocket ? "4rem" : "10rem"}
              event={Enviar}
              placeholder={uploading ? "Enviando..." : "Enviar"}
              background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
              borderRadius="10px"
              padding={!PC && "10px"}
              fontSize={!PC && "12px"}
              disabled={uploading}
              />
              )}
              </DivSave> */
          )}
        </DivMain>
        <DivSave>
          <Button
            event={Fechar}
            width={Pocket ? "6rem" : "10rem"}
            placeholder={"Fechar"}
            background={"linear-gradient(135deg, #1a2e35 0%, #263654 100%)"}
            borderRadius="10px"
            padding={!PC && "10px"}
            fontSize={!PC && "12px"}
          />
        </DivSave>
      </Cardo>
    </Background>
  );
};

export default InsirirVerDocExemplar;
